import Services from 'core/services/store/auth/services';
import * as AuthActions from 'core/services/store/auth/actions';
import { Routes } from '../../routes';
import { $ } from '@starberry/components';

const HeaderMenu = {
  $: 'Flex',
  props: {
    display: { base: 'none', md: 'flex' },
  },
  menuItemProps: {
    
  },
  children: [
    {
      $: 'HeaderMenuItem',
      provide: ['auth'],
      props: {
        label: (_, context) => {
          return context?.state?.auth?.[0]?.user?.name || 'Visitor';
        },
        rightIcon: 'chevron-down',
        buttonProps: {
          fontWeight: $('theme.fontWeights.bold'),
          px: 0,
          _hover: {
            bg: 'transparent',
          },
          _focus: {
            bg: 'transparent',
          },
          _active: {
            bg: 'transparent',
          },
        },
        submenu: (_, context) => [
          {
            label: 'Profile',
            buttonProps: {
              onClick: () => {
                window.location.href = Routes.ProfilePage;
              },
            },
          },
          {
            label: 'Logout',
            buttonProps: {
              onClick: () => {
                const [, dispatch] = context?.state?.auth || [];
                Services(dispatch, AuthActions).logout();
                window.location.href = Routes.LoginPage;
              },
            },
          },
        ],
      },
    },
  ],
};

export default HeaderMenu;
